/* ══════════════════════════════════════════════════════════════════
   NewJaisa B2B — Main Scripts
   ══════════════════════════════════════════════════════════════════ */

/* ── ROI Calculator ──────────────────────────────────────────────────*/
const ROI_DATA = {
  desktop_basic:  { nj: 14999,  new_price: 45000 },
  desktop_mid:    { nj: 18500,  new_price: 50000 },
  desktop_high:   { nj: 28000,  new_price: 65000 },
  laptop_basic:   { nj: 20000,  new_price: 55000 },
  laptop_mid:     { nj: 26000,  new_price: 70000 },
  laptop_premium: { nj: 34000,  new_price: 90000 },
  aio:            { nj: 14999,  new_price: 40000 },
  monitor:        { nj: 8500,   new_price: 18000 },
};

function fmtINR(n) {
  if (n >= 10000000) return '₹' + (n/10000000).toFixed(1) + ' Cr';
  if (n >= 100000)   return '₹' + (n/100000).toFixed(1) + ' L';
  if (n >= 1000)     return '₹' + (n/1000).toFixed(1) + 'K';
  return '₹' + n.toLocaleString('en-IN');
}

function calcROI() {
  const type = document.getElementById('roi-type').value;
  const qty  = parseInt(document.getElementById('roi-qty').value) || 100;
  const warranty = parseInt(document.querySelector('input[name="roi-warranty"]:checked')?.value || 1);
  const model = document.querySelector('input[name="roi-model"]:checked')?.value || 'buy';
  const data  = ROI_DATA[type];
  if (!data) return;
  const warrantyAdd = warranty === 2 ? 1500 : warranty === 3 ? 3000 : 0;
  const njPerDevice  = data.nj + warrantyAdd;
  const newPerDevice = data.new_price;
  const njTotal  = njPerDevice * qty;
  const newTotal = newPerDevice * qty;
  const saving   = newTotal - njTotal;
  const pct      = Math.round((saving / newTotal) * 100);
  const monthly24 = Math.round(njPerDevice / 18);
  document.getElementById('roi-total-save').textContent = fmtINR(saving);
  document.getElementById('roi-save-pct').textContent = pct + '% savings vs buying new equivalents';
  document.getElementById('roi-nj-cost').textContent = fmtINR(njTotal);
  document.getElementById('roi-nj-per').textContent = fmtINR(njPerDevice) + ' per device';
  document.getElementById('roi-new-cost').textContent = fmtINR(newTotal);
  document.getElementById('roi-new-per').textContent = fmtINR(newPerDevice) + ' per device (equiv.)';
  document.getElementById('r-qty').textContent = qty.toLocaleString('en-IN') + ' devices';
  document.getElementById('r-nj').textContent = fmtINR(njTotal);
  document.getElementById('r-new').textContent = fmtINR(newTotal);
  document.getElementById('r-save').textContent = fmtINR(saving);
  document.getElementById('r-pct').textContent = pct + '% savings';
  const leaseRow = document.getElementById('roi-lease-row');
  if (model === 'lease') {
    leaseRow.style.display = 'block';
    document.getElementById('roi-monthly').textContent = fmtINR(monthly24 * qty) + '/month';
  } else {
    leaseRow.style.display = 'none';
  }
  ['1','2','3'].forEach(v => {
    const el = document.getElementById('w'+v);
    if (!el) return;
    const sel = warranty === parseInt(v);
    el.style.borderColor = sel ? '#03B4D7' : '#D1E9F5';
    el.style.color       = sel ? '#03B4D7' : '#6B7280';
    el.style.background  = sel ? '#E8F8FC' : '#fff';
  });
  ['buy','lease'].forEach(v => {
    const el = document.getElementById('m-'+v);
    if (!el) return;
    const sel = model === v;
    el.style.borderColor = sel ? '#03B4D7' : '#D1E9F5';
    el.style.color       = sel ? '#03B4D7' : '#6B7280';
    el.style.background  = sel ? '#E8F8FC' : '#fff';
  });
}

/* ── Lease Calculator ────────────────────────────────────────────────*/
function calcLease() {
  const qty   = parseInt(document.getElementById('lease-qty')?.value) || 0;
  const price = parseInt(document.getElementById('lease-type')?.value) || 22000;
  const term  = parseInt(document.getElementById('lease-term')?.value) || 24;
  if (!qty) return;
  const rate    = term === 12 ? 0.095 : term === 24 ? 0.052 : 0.037;
  const monthly = Math.round(price * rate * qty);
  const buyNew  = price * 1.8 * qty;
  const saving  = buyNew - (price * qty);
  document.getElementById('lease-monthly').textContent = fmtINR(monthly) + '/mo';
  document.getElementById('lease-saving').textContent  = fmtINR(saving) + ' saved';
}

/* ── Solution hero quick calc ────────────────────────────────────────*/
function calcSolROI() {
  const devices = parseInt(document.getElementById('sol-devices')?.value) || 0;
  const priceNJ = parseInt(document.getElementById('sol-type')?.value) || 22000;
  if (!devices) return;
  const priceNew = priceNJ * 2.3;
  const saving   = Math.round((priceNew - priceNJ) * devices);
  document.getElementById('sol-result').style.display = 'block';
  document.getElementById('sol-saving').textContent   = fmtINR(saving);
  document.getElementById('sol-detail').textContent   =
    fmtINR(priceNJ * devices) + ' (NewJaisa) vs ' + fmtINR(Math.round(priceNew * devices)) + ' (New)';
}

/* ── Pricing tabs ────────────────────────────────────────────────────*/
function showPricingTab(tab, btn) {
  ['laptops','desktops','aio','monitors','accessories'].forEach(t => {
    const el = document.getElementById('ptab-' + t);
    if (el) el.style.display = 'none';
  });
  const el = document.getElementById('ptab-' + tab);
  if (el) el.style.display = 'block';
  document.querySelectorAll('#pricing-switcher button').forEach(b => {
    b.style.background = 'transparent';
    b.style.color = '#6B7280';
  });
  if (btn) { btn.style.background = '#03B4D7'; btn.style.color = '#fff'; }
}

/* ── Logo carousel ───────────────────────────────────────────────────*/
function logoScroll(dir) {
  const track = document.querySelector('.logo-track');
  if (!track) return;
  const step = 220;
  const maxScroll = track.scrollWidth - track.clientWidth;
  let current = parseInt(track.dataset.scroll || '0');
  current = Math.max(0, Math.min(maxScroll, current + dir * step));
  track.dataset.scroll = current;
  track.style.transform = 'translateX(-' + current + 'px)';
  const btnL = document.querySelector('.logo-btn-l');
  const btnR = document.querySelector('.logo-btn-r');
  if (btnL) btnL.style.opacity = current <= 0 ? '0.3' : '1';
  if (btnR) btnR.style.opacity = current >= maxScroll ? '0.3' : '1';
}

/* ── Wireframe page navigation ───────────────────────────────────────*/
function navTo(id) {
  document.querySelectorAll('.page-frame').forEach(f => f.classList.remove('active'));
  document.querySelectorAll('.page-nav-btn').forEach(b => {
    b.classList.remove('active');
    b.style.color = '';
    b.style.borderBottomColor = '';
  });
  const target = document.getElementById('page-' + id);
  if (target) target.classList.add('active');
  document.querySelectorAll('.page-nav-btn').forEach(b => {
    const oc = b.getAttribute('onclick') || '';
    if (oc.includes("'" + id + "'") || oc.includes('"' + id + '"')) {
      b.classList.add('active');
      b.style.color = 'var(--primary)';
      b.style.borderBottomColor = 'var(--primary)';
    }
  });
  const ca = document.querySelector('.canvas-area');
  if (ca) ca.scrollTop = 0;
  closeNavbarMega();
}

function showPage(id) {
  document.querySelectorAll('.page-frame').forEach(f => f.classList.remove('active'));
  document.querySelectorAll('.page-nav-btn').forEach(b => {
    b.classList.remove('active');
    b.style.color = '';
    b.style.borderBottomColor = '';
  });
  const target = document.getElementById('page-' + id);
  if (target) target.classList.add('active');
  document.querySelectorAll('.page-nav-btn').forEach(b => {
    const oc = b.getAttribute('onclick') || '';
    if (oc.includes("'" + id + "'") || oc.includes('"' + id + '"')) {
      b.classList.add('active');
      b.style.color = 'var(--primary)';
      b.style.borderBottomColor = 'var(--primary)';
    }
  });
  const ca = document.querySelector('.canvas-area');
  if (ca) ca.scrollTop = 0;
  closeNavbarMega();
}

/* ── Company page tab switcher ───────────────────────────────────────*/
function switchCoTab(name, el) {
  document.querySelectorAll('.co-panel').forEach(p => {
    p.classList.remove('active');
    p.style.display = 'none';
  });
  document.querySelectorAll('.co-tab').forEach(t => {
    t.style.color = 'var(--gray-500)';
    t.style.borderBottomColor = 'transparent';
  });
  const panel = document.getElementById('co-' + name);
  if (panel) { panel.style.display = 'block'; panel.classList.add('active'); }
  if (el) {
    el.style.color = 'var(--primary)';
    el.style.borderBottomColor = 'var(--primary)';
  }
}

/* ══════════════════════════════════════════════════════════════════
   MEGA MENU — NAVBAR
   • Click trigger → open panel
   • Click same trigger again → close (toggle)
   • Click outside navbar → close
   • ESC key → close
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var _openName    = null;
  var _openTrigger = null;

  /* Reset all trigger styles within a navbar */
  function _resetTrigger(t) {
    t.classList.remove('is-active');
    t.style.color = '';
    t.style.background = '';
    t.style.borderBottom = '';
    var ch = t.querySelector('.chevron');
    if (ch) ch.textContent = '▼';
    t.setAttribute('aria-expanded', 'false');
  }

  /* Close the navbar dropdown */
  window.closeNavbarMega = function () {
    if (!_openName) return;
    var panel = document.getElementById('mega-' + _openName);
    if (panel) panel.classList.remove('is-active');
    var menu = document.getElementById('nj-mega-menu');
    if (menu) menu.classList.remove('is-open');
    var bd = document.getElementById('nj-mega-backdrop');
    if (bd) bd.classList.remove('is-active');
    if (_openTrigger) _resetTrigger(_openTrigger);
    _openName    = null;
    _openTrigger = null;
  };

  /* Open a panel by name */
  function _openPanel(name, triggerEl) {
    /* Close previously open panel (different name) */
    if (_openName && _openName !== name) {
      var prev = document.getElementById('mega-' + _openName);
      if (prev) prev.classList.remove('is-active');
      if (_openTrigger) _resetTrigger(_openTrigger);
    }

    var panel = document.getElementById('mega-' + name);
    if (!panel) return;

    var menu = document.getElementById('nj-mega-menu');
    if (menu) menu.classList.add('is-open');
    panel.classList.add('is-active');

    var bd = document.getElementById('nj-mega-backdrop');
    if (bd) bd.classList.add('is-active');

    if (triggerEl) {
      triggerEl.classList.add('is-active');
      var ch = triggerEl.querySelector('.chevron');
      if (ch) ch.textContent = '▲';
      triggerEl.setAttribute('aria-expanded', 'true');
    }

    _openName    = name;
    _openTrigger = triggerEl || null;
  }

  /* Public switchMega — handles both navbar dropdown & wireframe page-mega */
  window.switchMega = function (name, el) {
    var insideNavbar = el && typeof el.closest === 'function' && el.closest('#nj-navbar');

    if (insideNavbar) {
      /* Navbar behaviour: click to open, click again to close */
      if (_openName === name) {
        window.closeNavbarMega();
      } else {
        _openPanel(name, el);
      }
    } else {
      /* Legacy wireframe page-mega behaviour — unchanged */
      document.querySelectorAll('.mega-panel').forEach(function (p) {
        p.classList.remove('active');
        p.style.display = 'none';
      });
      document.querySelectorAll('.mega-trigger').forEach(function (t) {
        t.style.color = '';
        t.style.background = '';
        t.style.borderBottom = '';
        var ch = t.querySelector('.chevron');
        if (ch) ch.textContent = '▼';
      });
      var panel = document.getElementById('mega-' + name);
      if (panel) { panel.style.display = 'block'; panel.classList.add('active'); }
      if (el) {
        el.style.color       = 'var(--primary)';
        el.style.background  = 'rgba(3,180,215,.15)';
        el.style.borderBottom = '2px solid var(--primary)';
        var ch = el.querySelector('.chevron');
        if (ch) ch.textContent = '▲';
      }
    }
  };

  /* Close on click outside navbar — use capture phase so it fires first */
  document.addEventListener('click', function (e) {
    if (!_openName) return;
    var nb = document.getElementById('nj-navbar');
    if (nb && !nb.contains(e.target)) {
      window.closeNavbarMega();
    }
  }, true);

  /* Close on ESC */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.closeNavbarMega();
      closeMobileNav();
    }
  });

  /* Wire up backdrop after DOM ready */
  document.addEventListener('DOMContentLoaded', function () {
    var bd = document.getElementById('nj-mega-backdrop');
    if (bd) bd.addEventListener('click', window.closeNavbarMega);
  });

}());

/* ══════════════════════════════════════════════════════════════════
   MOBILE NAV DRAWER
   ══════════════════════════════════════════════════════════════════ */

function toggleMobileNav() {
  var drawer  = document.getElementById('mobile-nav-drawer');
  var overlay = document.getElementById('mobile-nav-overlay');
  var burger  = document.getElementById('nj-hamburger');
  if (!drawer || !overlay) return;
  drawer.classList.contains('open')
    ? _closeMobileDrawer(drawer, overlay, burger)
    : _openMobileDrawer(drawer, overlay, burger);
}

function closeMobileNav() {
  _closeMobileDrawer(
    document.getElementById('mobile-nav-drawer'),
    document.getElementById('mobile-nav-overlay'),
    document.getElementById('nj-hamburger')
  );
}

function _openMobileDrawer(drawer, overlay, burger) {
  if (!drawer) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('open');
  if (burger)  { burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
  document.body.style.overflow = 'hidden';
  closeNavbarMega(); /* close mega if open */
}

function _closeMobileDrawer(drawer, overlay, burger) {
  if (!drawer) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.classList.remove('open');
  if (burger)  { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
  document.body.style.overflow = '';
}

/* Toggle sub-menus inside the mobile drawer */
function toggleMobileSubMenu(id) {
  var sub = document.getElementById('mobile-sub-' + id);
  var btn = document.getElementById('mobile-btn-' + id);
  if (!sub) return;
  var isOpen = sub.classList.contains('open');

  /* Close all other open sub-menus */
  document.querySelectorAll('.mobile-sub-menu.open').forEach(function (s) { s.classList.remove('open'); });
  document.querySelectorAll('.mobile-nav-item.is-active').forEach(function (b) {
    b.classList.remove('is-active');
    b.setAttribute('aria-expanded', 'false');
  });

  /* Open this one (unless it was already open — toggle closes it) */
  if (!isOpen) {
    sub.classList.add('open');
    if (btn) { btn.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true'); }
  }
}

/* ── DOMContentLoaded init ────────────────────────────────────────*/
window.addEventListener('DOMContentLoaded', function () {
  try { calcROI(); }   catch (e) {}
  try { calcLease(); } catch (e) {}
  try { initFAQ(); } catch (e) {}
});

/* ── ROI function stubs (overridden by inline scripts on specific pages) ──*/
window.updateROI        = window.updateROI        || function(){};
window.selectDeviceType = window.selectDeviceType || function(){};
window.selectTier       = window.selectTier       || function(){};
window.selectModel      = window.selectModel      || function(){};
window.selectTerm       = window.selectTerm       || function(){};

//14th March ROI calculator
document.addEventListener("DOMContentLoaded", function(){

  const qtyInput = document.querySelector('.roi-input-group input');
  const categorySelect = document.querySelector('.roi-input-group select');

  const newCostEl = document.querySelectorAll('.roi-num')[0];
  const njCostEl = document.querySelectorAll('.roi-num')[1];
  const saveEl = document.querySelector('.roi-result div[style*="grid-column"] div');

  const devicePrices = [
    { nj:21000, newp:45000 }, // Business Laptop
    { nj:14999, newp:40000 }, // Desktop
    { nj:14999, newp:38000 }  // All-in-one
  ];

  function formatINR(n){
    return "₹" + n.toLocaleString("en-IN");
  }

  // function calculate(){

  //   const qty = parseInt(qtyInput.value) || 0;
  //   const catIndex = categorySelect.selectedIndex;

  //   const baseNJ = devicePrices[catIndex].nj;
  //   const baseNew = devicePrices[catIndex].newp;

  //   let discount = 0;

  //   if(qty >= 500) discount = 0.15;
  //   else if(qty >= 100) discount = 0.12;
  //   else if(qty >= 50) discount = 0.08;
  //   else if(qty >= 10) discount = 0.05;

  //   const njPrice = Math.round(baseNJ * (1 - discount));

  //   const njTotal = njPrice * qty;
  //   const newTotal = baseNew * qty;

  //   const saving = newTotal - njTotal;

  //   const percent = Math.round((saving / newTotal) * 100);

  //   newCostEl.textContent = formatINR(newTotal);
  //   njCostEl.textContent = formatINR(njTotal);

  //   saveEl.textContent =
  //     "You Save " + formatINR(saving) + " (" + percent + "%)";
  // }
  //
  function calculate(){

  let qty = parseInt(qtyInput.value) || 0;

  // ✅ PREVENT NEGATIVE VALUES
  if (qty < 0) {
    qty = 0;
    qtyInput.value = 0; // reset UI also
  }

  const catIndex = categorySelect.selectedIndex;

  const baseNJ = devicePrices[catIndex].nj;
  const baseNew = devicePrices[catIndex].newp;

  let discount = 0;

  if(qty >= 500) discount = 0.15;
  else if(qty >= 100) discount = 0.12;
  else if(qty >= 50) discount = 0.08;
  else if(qty >= 10) discount = 0.05;

  const njPrice = Math.round(baseNJ * (1 - discount));

  const njTotal = njPrice * qty;
  const newTotal = baseNew * qty;

  const saving = newTotal - njTotal;

  const percent = newTotal > 0 ? Math.round((saving / newTotal) * 100) : 0; // ✅ safe divide

  newCostEl.textContent = formatINR(newTotal);
  njCostEl.textContent = formatINR(njTotal);

  saveEl.textContent =
    "You Save " + formatINR(saving) + " (" + percent + "%)";
}
//1st April for Minus Calculate

  qtyInput.addEventListener("input", calculate);
  categorySelect.addEventListener("change", calculate);

  calculate();

});


// 25th March FAQ Section 
 /* ── FAQ ACCORDION ──────────────────────────── */
function initFAQ() {
  document.querySelectorAll('.hc-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.hc-faq-item');
      if (!item) return;

      var isOpen = item.classList.contains('open');

      document.querySelectorAll('.hc-faq-item.open').forEach(function (i) {
        i.classList.remove('open');
        var q = i.querySelector('.hc-faq-q');
        if (q) q.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

//JS for B2B Industry Private

/* ═══════════════════════════════════════════════════
   NEWJAISA — STARTUPS & PRIVATE ENTERPRISE PAGE
   File: assets/component-startups.js
   Namespace: EntPage · No globals · No jQuery
   Note: No Final CTA → no scrollToCTA
═══════════════════════════════════════════════════ */

'use strict';

var EntPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── STAGE CONFIG ───────────────────────── */
  var STAGE_CONFIG = {
    bootstrap: { disc: 0,    leaseRate: 0.095 },
    seed:      { disc: 0.05, leaseRate: 0.08  },
    seriesa:   { disc: 0.08, leaseRate: 0.052 },
    seriesb:   { disc: 0.12, leaseRate: 0.038 },
    smb:       { disc: 0.08, leaseRate: 0.06  }
  };

  var activeStage = 'seriesa';

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── RUNWAY CALCULATOR ──────────────────── */
  function calcRunway() {
    var seatsEl  = $('ent-rc-seats');
    var deviceEl = $('ent-rc-device');
    if (!seatsEl || !deviceEl) return;

    var seats  = parseInt(seatsEl.value) || 0;
    var parts  = (deviceEl.value || '22000,55000').split(',');
    var nj     = parseInt(parts[0]) || 22000;
    var newP   = parseInt(parts[1]) || 55000;

    if (seats < 1) return;

    var stg     = STAGE_CONFIG[activeStage] || STAGE_CONFIG.seriesa;
    var volDisc = seats >= 100 ? 0.12 : seats >= 50 ? 0.08 : seats >= 10 ? 0.05 : 0;
    var disc    = Math.max(volDisc, stg.disc);

    var njUnit   = Math.round(nj * (1 - disc));
    var njTotal  = njUnit * seats;
    var newTotal = newP * seats;
    var saving   = newTotal - njTotal;
    var pct      = Math.round((saving / newTotal) * 100);
    var monthly  = Math.round(njUnit * stg.leaseRate * seats);

    var el1 = $('ent-rcr-nj');
    var el2 = $('ent-rcr-new');
    var el3 = $('ent-rcr-save');
    var el4 = $('ent-rcr-lease');
    var el5 = $('ent-rcr-disc');

    if (el1) el1.textContent = fmtINR(njTotal);
    if (el2) el2.textContent = fmtINR(newTotal);
    if (el3) el3.textContent = fmtINR(saving) + ' · ' + pct + '%';
    if (el4) el4.textContent = fmtINR(monthly) + '/mo';

    if (el5) {
      // if (disc > 0) {
      //   el5.textContent   = '✓ ' + (disc * 100).toFixed(0) + '% volume discount applied';
      //   el5.style.display = 'block';
      // } else {
      //   el5.style.display = 'none';
      // }
    }
  }

  /* ── STAGE PILLS ────────────────────────── */
  function initStagePills() {
    $$('.ent-stage-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.ent-stage-btn').forEach(function (b) { b.classList.remove('ent-on'); });
        btn.classList.add('ent-on');
        activeStage = btn.getAttribute('data-stage') || 'seriesa';
        calcRunway();
      });
    });
  }

  /* ── FAQ ACCORDION ──────────────────────── */
  function initFAQ() {
    $$('.ent-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.ent-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        $$('.ent-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.ent-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.ent-reveal').forEach(function (el) { el.classList.add('ent-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('ent-reveal') && !el.classList.contains('ent-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('ent-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.ent-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('ent-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Startup IT Procurement Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    initStagePills();

    var seatsEl  = $('ent-rc-seats');
    var deviceEl = $('ent-rc-device');
    if (seatsEl)  seatsEl.addEventListener('input',  calcRunway);
    if (deviceEl) deviceEl.addEventListener('change', calcRunway);
    calcRunway();

    initFAQ();
    initReveal();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  EntPage.init();
});

